import { CycleState } from "stores/cycle";
import { TaskState } from "stores/task";
import { Solution } from "types/Production";



export interface PlannerSession {
	type?: SESSION_TYPE
	draftId?: number
	/** lo STATE dello STORE CYCLE da visualizzare */
	cycle?: CycleState
	/** lo STATE dello STORE TASK da visualizzare */
	task?: TaskState
	/** valorizzato nel caso sia di type PREVIEW */
	solution?: Solution
}

/** il tipo di SESSIONE (che tipo di TAB nel PLANNER)*/
export enum SESSION_TYPE {
	/** è la TAB in PRODUZIONE */
	PROD,
	/** è una TAB DRAFT */
	DRAFT,
	/** tipicamete si tratta di una SOLUTION tirata fuori da AI PLANNING*/
	PREVIEW
}

export enum DRAFT_MODE {
	EDIT,
	READ
}

export enum DRAFT_STATUS_FILTER {
	//ALL = "ALL",
	CURRENTS = "currents",
	MERGED = "merged"
}
